import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold py-4 fs-6 w-275px",
  "data-kt-menu": "true"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "menu-item px-5" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-bell h3" }),
  /*#__PURE__*/_createTextVNode(" Notifications ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-2" }, null, -1)
const _hoisted_4 = { class: "menu-item px-5 scroller" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 0,
  class: "alert alert-warning",
  style: {"font-size":"12px"}
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 0,
  class: "badge bg-primary",
  style: {"font-size":"8px"}
}
const _hoisted_10 = { class: "d-grid gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      (_ctx.is_loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Loading..."))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_ctx.notification_data.length <= 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, " Notifikasi Kosong! "))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.notification_data, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "notif bg-light rounded mb-2 p-2 cursor-pointer hoverable",
                    style: {"font-size":"12px"},
                    key: index,
                    onClick: ($event: any) => (_ctx.readNotification(item, index))
                  }, [
                    _createTextVNode(" Crawlback pada tanggal " + _toDisplayString(_ctx.moment(item.created_at).format("YYYY-MM-DD HH:mm:ss")) + " telah selesai. ", 1),
                    (item.is_read == 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, " Belum Dibaca "))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_8))
                }), 128))
          ])),
      _createElementVNode("div", _hoisted_10, [
        (_ctx.notification_data.length < _ctx.notif_count)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn btn-primary btn-sm",
              type: "button",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.loadMore && _ctx.loadMore(...args)))
            }, _toDisplayString(_ctx.is_loadmore ? "Loading..." : "Load More"), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}